import { render } from "./course.vue?vue&type=template&id=34af8c9a&scoped=true"
import script from "./course.vue?vue&type=script&lang=js"
export * from "./course.vue?vue&type=script&lang=js"

import "./course.vue?vue&type=style&index=0&id=34af8c9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34af8c9a"]])

export default __exports__